import React, { lazy, Suspense } from 'react';
import Terms from './Terms';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from './Login';
import Development from "./AppDevelopment";
import ProtectedRoute from "./ProtectedRoute";
import Privacy from "./Privacy";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path";
//import AboutUs from "./Aboutus.js";
import {css} from "./ChatCss.js";
import {chartCss} from "./ChartCss.js"

const Shell = lazy(() => import("./Shell.js"));
//Local
//export const URL = "http://localhost:5000"
//Production
export const URL = "https://backendserale.onrender.com"

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.15.0/cdn/');

function App() {
  const protectedShell = (
    <ProtectedRoute>
      <Suspense fallback={<div role="status" aria-live="polite">Loading application...</div>}>
        <Shell />
      </Suspense>
    </ProtectedRoute>
  );
  return (

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/propertymanagement" />} />
        <Route path="/propertymanagement" element={protectedShell} />
+       <Route path="/proposal/:proposalIdvendor" element={protectedShell} />
        <Route path="/propertydevelopment" element={<Development />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/login" element={localStorage.getItem('authToken') ? <Navigate to="/propertymanagement" /> : <Login />} />
      </Routes>
      <style>{css}</style>
      <style>{chartCss}</style>
    </BrowserRouter>
  );
}

export default App;
